import { render, staticRenderFns } from "./admin-dashboard.vue?vue&type=template&id=c565a722&"
import script from "./admin-dashboard.vue?vue&type=script&lang=js&"
export * from "./admin-dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports